import Axios from "../utils/axiosInstance";
import fileSaver from "file-saver";

// API for creating Installation
export const postInstallation = (payload, headers) => {
  return Axios.post(`/installation/addInstallationDetails`, payload, {
    // headers: { Authorization: `Bearer ${token}` },
    headers,
  });
};

// API for getting list of all installation
export const getInstallationDetails = (pageNo, fkUserId, role, headers) => {
  return Axios.get(
    `/installation/getInstallationDetails/${pageNo}?fkUserId=${fkUserId}&role=${role}`,
    {
      headers,
    }
  );
};

// API for getting list of all field visit by from and to date
export const getAllIntstallationByDate = (pageNo, fromDate, toDate) => {
  let token = sessionStorage.getItem("token");
  let role = sessionStorage.getItem("role");
  let fkUserId = sessionStorage.getItem("pkUserId");
  return Axios.get(
    `/installation/getInstallationDetailsBetweenTwoDate/${pageNo}?fromDate=${fromDate}&toDate=${toDate}&fkUserId=${fkUserId}&role=${role}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
};

export const getInstallationPdfDownload = (fromDate, toDate) => {
  let token = sessionStorage.getItem("token");
  let fileType = ["Pdf"];
  // let jobType = ["field visit"];
  let role = sessionStorage.getItem("role");
  let fkUserId = sessionStorage.getItem("pkUserId");
  return Axios.get(
    `/installation/getInstallationReportBetweenTwoDatePdfExcel?fileType=${fileType}&role=${role}&fkUserId=${fkUserId}&fromDate=${fromDate}&toDate=${toDate}`,
    {
      headers: { Authorization: `Bearer ${token}` },
      responseType: "arraybuffer",
    }
  ).then((response) => {
    var blob = new Blob([response.data], { type: "application/pdf" });
    fileSaver.saveAs(blob, `installationreportbetweentwodatepdf.pdf`);
  });
};

export const getServiceInstallationPdf = (token, fileType, role, fkUserId) => {
  return Axios.get(
    `/installation/getInstallationExcelAndPdf?fileType=${fileType}&role=${role}&fkUserId=${fkUserId}`,
    {
      headers: { Authorization: `Bearer ${token}` },
      responseType: "arraybuffer",
    }
  ).then((response) => {
    let blob = new Blob([response.data], { type: "application/pdf" });
    fileSaver.saveAs(blob, "installationreportpdf.pdf");
  });
};


export const getCalibrationReportPdf = () => {
  let fkUserId = sessionStorage.getItem("pkUserId");
  let role = sessionStorage.getItem("role");
  let token = sessionStorage.getItem("token");
  let jobType = ["calibration"];
  let fileType = ["Pdf"];
  return Axios.get(
    `/calibration/getCalibrationReportPdfExcel?fileType=${fileType}&jobType=${jobType}&role=${role}&fkUserId=${fkUserId}`,
    {
      headers: { Authorization: `Bearer ${token}` },
      responseType: "arraybuffer",
    }
  ).then((response) => {
    var blob = new Blob([response.data], { type: "application/pdf" });
    fileSaver.saveAs(blob, `calibrationreportpdf.pdf`);
  });
};


// export const getCalibrationReportPdf = (
//   token,
//   fileType,
//   role,
//   fkUserId
// ) => {
//   return Axios.get(
//     `getCalibrationReportPdfExcel?fileType=${fileType}&fkUserId=${fkUserId}&role=${role}`,
//     {
//       headers: { Authorization: `Bearer ${token}` },
//       responseType: "arraybuffer",
//     }
//   ).then((response) => {
//     let blob = new Blob([response.data], { type: "application/pdf" });
//     fileSaver.saveAs(blob, "calibrationreportpdf.pdf");
//   });
// };

// export const getServiceFieldIssuePdf = (token, fileType, role, fkUserId) => {
//   return Axios.get(
//     `getFieldIssueReportPdfExcel?fileType=${fileType}&role=${role}&fkUserId=${fkUserId}`,
//     {
//       headers: { Authorization: `Bearer ${token}` },
//       responseType: "arraybuffer",
//     }
//   ).then((response) => {
//     let blob = new Blob([response.data], { type: "application/pdf" });
//     fileSaver.saveAs(blob, "fieldissuereportpdf.pdf");
//   });
// };


export const getServiceFieldIssuePdf = () => {
  let fkUserId = sessionStorage.getItem("pkUserId");
  let role = sessionStorage.getItem("role");
  let token = sessionStorage.getItem("token");
  let jobType = ["field visit"];
  let fileType = ["Pdf"];
  return Axios.get(
    `/fieldjob/getFieldIssueReportPdfExcel?fileType=${fileType}&jobType=${jobType}&role=${role}&fkUserId=${fkUserId}`,
    {
      headers: { Authorization: `Bearer ${token}` },
      responseType: "arraybuffer",
    }
  ).then((response) => {
    var blob = new Blob([response.data], { type: "application/pdf" });
    fileSaver.saveAs(blob, `fieldissuereportpdf.pdf`);
  });
};

export const getInstallationExcelDownload = (fromDate, toDate) => {
  let token = sessionStorage.getItem("token");
  let fileType = ["Excel"];
  let role = sessionStorage.getItem("role");
  let fkUserId = sessionStorage.getItem("pkUserId");
  return Axios.get(
    `/installation/getInstallationReportBetweenTwoDatePdfExcel?fileType=${fileType}&role=${role}&fkUserId=${fkUserId}&fromDate=${fromDate}&toDate=${toDate}`,
    {
      headers: { Authorization: `Bearer ${token}` },
      responseType: "arraybuffer",
    }
  ).then((response) => {
    var blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    fileSaver.saveAs(blob, `installationreportbetweentwodateexcel.xlsx`);
  });
};

// API for creating Field Issue
// export const postFieldIssue = (payload, headers) => {
//   return Axios.post(`addFieldIssueDetailsX`, payload, {
//     headers,
//   });
// };


// close field job details using image and dispenser for otp jobs
export const postFieldIssuecloseworkorder = (payload) => {
  let token = sessionStorage.getItem("token");
  return Axios.post(`/fieldjob/WorkOrderClosedForFieldIssueDetails`, payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
};
  

// close field job for non otp when operation type is (time,date and rate change )
export const postFieldNonOtpJobClose = (payload) => {
  let token = sessionStorage.getItem("token");
  return Axios.post(`WorkOrderClosedFornonotpFieldIssueDetails`, payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const postArkValidationFieldIssue = (payload) => {
  let token = sessionStorage.getItem("token");
  return Axios.post(`addFieldIssueDetails`, payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

// API for getting list of all installation
export const getFieldIssueDetails = (pageNo, fkUserId, role, headers) => {
  return Axios.get(
    `/fieldjob/getFieldIssueDetails/${pageNo}?fkUserId=${fkUserId}&role=${role}`,
    {
      headers,
    }
  );
};

export const getServiceInstallationExcel = () => {
  let fkUserId = sessionStorage.getItem("pkUserId");
  let role = sessionStorage.getItem("role");
  let token = sessionStorage.getItem("token");
  let fileType = ["Excel"];
  return Axios.get(
    `getInstallationExcelAndPdf?fileType=${fileType}&role=${role}&fkUserId=${fkUserId}`,
    {
      headers: { Authorization: `Bearer ${token}` },
      responseType: "arraybuffer",
    }
    ).then((response) => {
      var blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      fileSaver.saveAs(blob, `installationreportexcel.xlsx`);
    });
};

export const getServiceCalibrationExcel = () => {
  let fkUserId = sessionStorage.getItem("pkUserId");
  let role = sessionStorage.getItem("role");
  let token = sessionStorage.getItem("token");
  let fileType = ["Excel"];
  return Axios.get(
    `/calibration/getCalibrationReportPdfExcel?fileType=${fileType}&fkUserId=${fkUserId}&role=${role}`,
    {
      headers: { Authorization: `Bearer ${token}` },
      responseType: "arraybuffer",
    }
    ).then((response) => {
      var blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      fileSaver.saveAs(blob, `calibrationreportexcel.xlsx`);
    });
};

export const getServiceFieldIssueExcel = () => {
  let fkUserId = sessionStorage.getItem("pkUserId");
  let role = sessionStorage.getItem("role");
  let token = sessionStorage.getItem("token");
  let fileType = ["Excel"];
  return Axios.get(
    `/fieldjob/getFieldIssueReportPdfExcel?fileType=${fileType}&role=${role}&fkUserId=${fkUserId}`,
    {
      headers: { Authorization: `Bearer ${token}` },
      responseType: "arraybuffer",
    }
    ).then((response) => {
      var blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      fileSaver.saveAs(blob, `fieldissuereportexcel.xlsx`);
    });
};

// export const getFieldIssuePdfDownload = (fromDate, toDate) => {
//   let token = sessionStorage.getItem("token");
//   let fileType = ["pdf"];
//   let role = sessionStorage.getItem("role");
//   let fkUserId = sessionStorage.getItem("pkUserId");
//   return Axios.get(
//     `getFieldIssueReportBetweenTwoDatePdfExcel?fileType=${fileType}&role=${role}&fkUserId=${fkUserId}&fromDate=${fromDate}&toDate=${toDate}`,
//     {
//       headers: { Authorization: `Bearer ${token}` },
//       responseType: "arraybuffer",
//     }
//   ).then((response) => {
//     var blob = new Blob([response.data], { type: "application/pdf" });
//     fileSaver.saveAs(blob, `fieldissuereportbetweentwodatepdf.pdf`);
//   });
// };

export const getFieldIssuePdfDownload = (fromDate, toDate) => {
  let token = sessionStorage.getItem("token");
  let role = sessionStorage.getItem("role");
  let fkUserId = sessionStorage.getItem("pkUserId");
  let fileType = ["Pdf"];
  let jobType = ["field visit"];
  return Axios.get(
    `/fieldjob/getFieldIssueReportBetweenTwoDatePdfExcel?fileType=${fileType}&jobType=${jobType}&fromDate=${fromDate}
    &toDate=${toDate}&role=${role}&fkUserId=${fkUserId}`,
    {
      headers: { Authorization: `Bearer ${token}` },
      responseType: "arraybuffer",
    }
  ).then((response) => {
    var blob = new Blob([response.data], { type: "application/pdf" });
    fileSaver.saveAs(blob, `fieldissuereportbetweentwodatepdf.pdf`);
  });
};

export const getFieldIssueExcelDownload = (fromDate, toDate) => {
  let token = sessionStorage.getItem("token");
  let fileType = ["Excel"];
  let role = sessionStorage.getItem("role");
  let jobType = ["field visit"];
  let fkUserId = sessionStorage.getItem("pkUserId");
  return Axios.get(
    `/fieldjob/getFieldIssueReportBetweenTwoDatePdfExcel?fileType=${fileType}&role=${role}&fkUserId=${fkUserId}&fromDate=${fromDate}&jobType=${jobType}&toDate=${toDate}`,
    {
      headers: { Authorization: `Bearer ${token}` },
      responseType: "arraybuffer",
    }
  ).then((response) => {
    var blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    fileSaver.saveAs(blob, `fieldissuereportbetweentwodateexcel.xlsx`);
  });
};

// API for getting list of all field visit by from and to date
export const getAllFieldIssueByDate = (pageNo, fromDate, toDate) => {
  let token = sessionStorage.getItem("token");
  let role = sessionStorage.getItem("role");
  let fkUserId = sessionStorage.getItem("pkUserId");
  let jobType = ["field visit"];
  return Axios.get(
    `/fieldjob/getFieldIssueDetailsBetweenDate/${pageNo}?fromDate=${fromDate}&toDate=${toDate}&fkUserId=${fkUserId}&jobType=${jobType}&role=${role}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
};

// API for creating Calibration Details old api
export const postCalibrationDetails = (payload, headers) => {
  return Axios.post(`/calibration/addCalibrationDetails`, payload, {
    headers: headers,
  });
};


// api for post calibration start close details with images and disp number
export const postCalibrationstartDetailscloseofimages = (payload, headers) => {
  return Axios.post(`/calibration/addCalibrationDetailsWorkOrderClose`, payload, {
    headers: headers,
  });
};


// api for get otp send for calibration start form
export const postGetotpDetailscalistart = (payload, headers) => {
  return Axios.post(`/calibration/addCalibrationDetailsForGetOtp`, payload, {
headers: headers,
  });
};

// api for get otp send for calibration end form
export const postGetotpDetailscaliEnd = (payload, headers) => {
  return Axios.post(`/calibration/endingOtpVeryficationCalibrationDetailsForGetMultipleOTP`, payload, {
headers: headers,
  });
};


// api for get otp send for field job form
export const  postGetotpDetailsFieljob = (payload, headers) => {
  return Axios.post(`/fieldjob/addFieldIssueDetailsXForMultipleOtp`, payload, {
headers: headers,
  });
};





// export const postEndingARK = (payload, headers) => {
//   return Axios.post(`endingOtpVeryficationCalibrationDetails`, payload, {
//     // headers: { Authorization: `Bearer ${token}` },
//     headers: headers,
//   });
// };

// close calibration end form work order
export const postEndingcloseCalibration = (payload, headers) => {
  return Axios.post(`/calibration/endingOtpCloseWorkOrder`, payload, {
    // headers: { Authorization: `Bearer ${token}` },
    headers: headers,
  });
};

// API for getting list of all Calibration
export const getCalibrationList = (pageNo, fkUserId, role, headers) => {
  return Axios.get(
    `/calibration/getCalibrationDetails/${pageNo}?fkUserId=${fkUserId}&role=${role}`,
    {
      headers,
    }
  );
};

// API for getting Failed Ark list of all Calibration
export const getFailedArkList = (pageNo, fkUserId, role, headers) => {
  return Axios.get(
    `getArkVerification/${pageNo}?fkUserId=${fkUserId}&role=${role}`,
    {
      headers,
    }
  );
};

// API for getting list of all field visit by from and to date
export const getAllCalibrationIssueByDate = (pageNo, fromDate, toDate) => {
  let token = sessionStorage.getItem("token");
  let role = sessionStorage.getItem("role");
  let jobType = ["calibration"];
  let fkUserId = sessionStorage.getItem("pkUserId");
  return Axios.get(
    `/calibration/getCalibrationDetailsBetweenDate/${pageNo}?fromDate=${fromDate}&toDate=${toDate}&jobType=${jobType}&fkUserId=${fkUserId}&role=${role}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
};

export const getClibrationPdfDownload = (fromDate, toDate) => {
  let token = sessionStorage.getItem("token");
  let fileType = ["Pdf"];
  let jobType = ["calibration"];
  let role = sessionStorage.getItem("role");
  let fkUserId = sessionStorage.getItem("pkUserId");
  return Axios.get(
    `/calibration/getCalibrationReportBetweenTwoDatePdfExcel?fileType=${fileType}&jobType=${jobType}&role=${role}&fkUserId=${fkUserId}&fromDate=${fromDate}&toDate=${toDate}`,
    {
      headers: { Authorization: `Bearer ${token}` },
      responseType: "arraybuffer",
    }
  ).then((response) => {
    var blob = new Blob([response.data], { type: "application/pdf" });
    fileSaver.saveAs(blob, `calibrationreportbetweentwodatepdf.pdf`);
  });
};

export const getCalibrationExcelDownload = (fromDate, toDate) => {
  let token = sessionStorage.getItem("token");
  let fileType = ["Excel"];
  let role = sessionStorage.getItem("role");
  let fkUserId = sessionStorage.getItem("pkUserId");
  return Axios.get(
    `/calibration/getCalibrationReportBetweenTwoDatePdfExcel?fileType=${fileType}&role=${role}&fkUserId=${fkUserId}&fromDate=${fromDate}&toDate=${toDate}`,
    {
      headers: { Authorization: `Bearer ${token}` },
      responseType: "arraybuffer",
    }
  ).then((response) => {
    var blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    fileSaver.saveAs(blob, `calibrationreportbetweentwodateexcel.xlsx`);
  });
};

// Api to get board details for installation against dispenserNo / dispenserSrNo
export const getInstallationDetailsGetData = (dispenserNo, headers) => {
  return Axios.get(`getInstallationDetailsForGetData/${dispenserNo}`, {
    headers,
  });
};

// Api to get board details for Calibration against dispenserNo / dispenserSrNo
export const getCalibrationDetailsGetData = (workOrderSerialNo, headers) => {
  return Axios.get(`/calibration/getCalibrationDetailsForGetData/${workOrderSerialNo}`, {
    headers,
  });
};

// Api to get board details for FieldIssue against dispenserNo / dispenserSrNo
export const getFieldIssueDetailsGetData = (dispenserNo, headers) => {
  return Axios.get(`getFieldIssueDetailsForGetData/${dispenserNo}`, {
    headers,
  });
};

// export const getDataScannedOrNot = (dispenserNo, headers) => {
//   return Axios.get(`checkgetDataScanedOrNot/${dispenserNo}`, {
//     headers,
//   });
// };

// export const getAllDataOfDispenserSrNo = (dispenserNo, headers) => {
//   return Axios.get(`getAllDataOfDispenserSrNo/${dispenserNo}`, {
//     headers,
//   });
// };



// old scanning api for installation with scanning screen

export const getDataScannedOrNotinstallation = (dispenserNo, headers) => {
  return Axios.get(`checkgetDataScanedOrNot/${dispenserNo}`, {
    headers,
  }).then(response => {
    console.log(`getDataScannedOrNot Success for ${dispenserNo}:`, response);
    return response; // Ensure the response is still returned for further handling
  }).catch(error => {
    console.error(`getDataScannedOrNot Error for ${dispenserNo}:`, error);
    throw error; // Re-throw error for further handling
  });
};



// Function to get data scanned or not for given dispenser // new intigrated api for calibration start,end and field job
export const getDataScannedOrNot = async (dispenserNo, operationType, subOperationType, headers) => {
  try {
  
    const response = await Axios.get(`checkgetDataScanedOrNot/${dispenserNo}`, {
      headers,
      params: {
        OperationType: operationType, 
        SubOperationType: subOperationType 
      }
    });
    console.log(`getDataScannedOrNot Success for ${dispenserNo}:`, response);
    return response;
  } catch (error) {
    console.error(`getDataScannedOrNot Error for ${dispenserNo}:`, error);
    throw error; 
  }
};


export const getAllDataOfDispenserSrNo = (dispenserNo, headers) => {
  return Axios.get(`/production/getAllDataOfDispenserSrNo/${dispenserNo}`, {
    headers,
  }).then(response => {
    console.log(`getAllDataOfDispenserSrNo Success for ${dispenserNo}:`, response);
    return response; // Ensure the response is still returned for further handling
  }).catch(error => {
    console.error(`getAllDataOfDispenserSrNo Error for ${dispenserNo}:`, error);
    throw error; // Re-throw error for further handling
  });
};




export const getservicesinstallationDispenserSerialNumber = (pageNo, dispenserSrNo) => {
  const role = sessionStorage.getItem("role");
  const fkUserId = sessionStorage.getItem("pkUserId");
  const token = sessionStorage.getItem("token");

  console.log('Role:', role, 'FkUserId:', fkUserId, 'Dispenser Serial Number:', dispenserSrNo);

  const url = `/installation/getInstallationDetailsListByDispenser/${pageNo}?role=${role}&fkUserId=${fkUserId}&dispenserSrNo=${dispenserSrNo}`;

  const config = {
    headers: {
      'Authorization': `Bearer ${token}`, 
 
    }
  };

  return Axios.get(url, config)
    .then(response => {
      console.log('Response Data:', response.data);
      return response.data;
    })
    .catch(error => {
      console.error('There was an error fetching the dispenser serial number:', error);
      if (error.response) {

        console.error('Response data:', error.response.data);
        console.error('Status:', error.response.status);
        console.error('Headers:', error.response.headers);
      } else if (error.request) {

        console.error('The request was made but no response was received', error.request);
      } else {

        console.error('Error', error.message);
      }
      console.error('Config:', error.config);
    });
};


export const getservicesfieldissueDispenserSerialNumber = (pageNo, dispenserSrNo) => {
  const role = sessionStorage.getItem("role");
  const pkFieldIssueHistoryId = sessionStorage.getItem("pkFieldIssueHistoryId");
  const token = sessionStorage.getItem("token");

  console.log('Role:', role, 'pkFieldIssueHistoryId:', pkFieldIssueHistoryId, 'Dispenser Serial Number:', dispenserSrNo);

  const url = `/fieldjob/getFieldIssueHistoryListByDispenser/${pageNo}?role=${role}&pkFieldIssueHistoryId=${pkFieldIssueHistoryId}&dispenserSrNo=${dispenserSrNo}`;

  const config = {
    headers: {
      'Authorization': `Bearer ${token}`, 
 
    }
  };

  return Axios.get(url, config)
    .then(response => {
      console.log('Response Data:', response.data);
      return response.data;
    })
    .catch(error => {
      console.error('There was an error fetching the dispenser serial number:', error);
      if (error.response) {

        console.error('Response data:', error.response.data);
        console.error('Status:', error.response.status);
        console.error('Headers:', error.response.headers);
      } else if (error.request) {

        console.error('The request was made but no response was received', error.request);
      } else {

        console.error('Error', error.message);
      }
      console.error('Config:', error.config);
    });
};


export const getservicescalibrationdispensersereialNo = (pageNo, dispenserSrNo) => {
  const role = sessionStorage.getItem("role");
  const fkUserId = sessionStorage.getItem("pkUserId");
  const token = sessionStorage.getItem("token");

  console.log('Role:', role, 'FkUserId:', fkUserId, 'Dispenser Serial Number:', dispenserSrNo);

  const url = `/calibration/getCalibrationDetailsListByDispenser/${pageNo}?role=${role}&fkUserId=${fkUserId}&dispenserSrNo=${dispenserSrNo}`;

  const config = {
    headers: {
      'Authorization': `Bearer ${token}`, 
 
    }
  };

  return Axios.get(url, config)
    .then(response => {
      console.log('Response Data:', response.data);
      return response.data;
    })
    .catch(error => {
      console.error('There was an error fetching the dispenser serial number:', error);
      if (error.response) {

        console.error('Response data:', error.response.data);
        console.error('Status:', error.response.status);
        console.error('Headers:', error.response.headers);
      } else if (error.request) {

        console.error('The request was made but no response was received', error.request);
      } else {

        console.error('Error', error.message);
      }
      console.error('Config:', error.config);
    });
};





